import { DateTime } from 'luxon'

import { Timeslot } from './timeslot'

export class Schedule {
	public id: number
	public title: string
	public titleTranlations: Record<string, string>
	public description: string | null
	public descriptionTranlations: Record<string, string>
	public contentCategoryIds: number[]
	public public: boolean
	public resellerId?: number | null
	public hash: string
	public metadata: ScheduleMetadata
	public createdAt: DateTime
	public updatedAt: DateTime

	// Pivot data
	public favorite?: boolean
	public reviewed?: boolean

	// Relationships
	public timeslots: Timeslot[]

	constructor(data: {
		id: number
		title: string
		titleTranlations: Record<string, string>
		description: string | null
		descriptionTranlations: Record<string, string>
		contentCategoryIds: number[]
		public: boolean
		resellerId?: number | null
		hash: string
		metadata: ScheduleMetadata
		createdAt: DateTime
		updatedAt: DateTime
		favorite?: boolean
		reviewed?: boolean
		timeslots: Timeslot[]
	}) {
		this.id = data.id
		this.title = data.title
		this.titleTranlations = data.titleTranlations
		this.description = data.description
		this.descriptionTranlations = data.descriptionTranlations
		this.contentCategoryIds = data.contentCategoryIds
		this.public = data.public
		this.resellerId = data.resellerId
		this.hash = data.hash
		this.metadata = data.metadata
		this.createdAt = data.createdAt
		this.updatedAt = data.updatedAt
		this.favorite = data.favorite
		this.reviewed = data.reviewed
		this.timeslots = data.timeslots
	}

	static create(data: Partial<Schedule>): Schedule {
		const defaultData = {
			id: 0,
			title: '',
			titleTranlations: {},
			description: null,
			descriptionTranlations: {},
			contentCategoryIds: [],
			public: false,
			hash: '',
			metadata: ScheduleMetadata.create({
				smallCovers: [],
				mediumCovers: [],
			}),
			createdAt: DateTime.now(),
			updatedAt: DateTime.now(),
			timeslots: [],
		}

		return new Schedule({
			...defaultData,
			...data,
		})
	}

	get titleTranslations(): Record<string, string> {
		return this.titleTranlations
	}

	get descriptionTranslations(): Record<string, string> {
		return this.descriptionTranlations
	}

	getLocalizedTitle(locale: string): string {
		return this.titleTranlations[locale] || this.titleTranlations['en-US'] || ''
	}

	getLocalizedDescription(locale: string): string {
		return (
			this.descriptionTranlations[locale] ||
			this.descriptionTranlations['en-US'] ||
			''
		)
	}
}

export class ScheduleMetadata {
	public smallCovers: string[]
	public mediumCovers: string[]

	constructor(data: { smallCovers: string[]; mediumCovers: string[] }) {
		this.smallCovers = data.smallCovers
		this.mediumCovers = data.mediumCovers
	}

	static create(data: Partial<ScheduleMetadata>): ScheduleMetadata {
		const defaultData = {
			smallCovers: [],
			mediumCovers: [],
		}

		return new ScheduleMetadata({
			...defaultData,
			...data,
		})
	}
}
